"use strict";
/* eslint-disable react/prop-types */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var wagtailConfig_1 = require("../../config/wagtailConfig");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var PageCount = function (_a) {
    var page = _a.page;
    var count = page.children.count;
    return (react_1["default"].createElement("a", { href: "" + wagtailConfig_1.ADMIN_URLS.PAGES + page.id + "/", className: "c-explorer__see-more" },
        wagtailConfig_1.STRINGS.SEE_ALL,
        react_1["default"].createElement("span", null, " " + count + " " + (count === 1 ? wagtailConfig_1.STRINGS.PAGE.toLowerCase() : wagtailConfig_1.STRINGS.PAGES.toLowerCase())),
        react_1["default"].createElement(Icon_1["default"], { name: "arrow-right" })));
};
exports["default"] = PageCount;
